"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultIsSelected = exports.defaultGetOptionValue = exports.defaultGetOptionSecondaryLabel = exports.defaultGetOptionLabel = exports["default"] = exports.TYPE_GROUP = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var ReactVirtualized = _interopRequireWildcard(require("react-virtualized"));
var _ListSubheader = _interopRequireDefault(require("../../ListSubheader"));
var _NoResults = _interopRequireDefault(require("../../NoResults/NoResults"));
var _DataListItem = _interopRequireDefault(require("./DataListItem"));
var _lodash = require("lodash");
var _groupBy2 = _interopRequireDefault(require("lodash/groupBy"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TYPE_GROUP = exports.TYPE_GROUP = 'group';
var useGroupedOptions = function useGroupedOptions(_ref) {
  var options = _ref.options,
    groupBy = _ref.groupBy,
    getGroupDataFromItems = _ref.getGroupDataFromItems;
  return (0, _react.useMemo)(function () {
    if (groupBy) {
      var groupMap = (0, _groupBy2["default"])(options, function (opt) {
        return (0, _lodash.get)(opt, groupBy);
      });
      var groupKeys = Object.keys(groupMap);
      return groupKeys.reduce(function (optionsWithGroups, groupKey) {
        var groupOptions = groupMap[groupKey];
        var result = {
          key: groupKey,
          type: TYPE_GROUP,
          label: groupKey,
          count: groupOptions.length
        };
        if (getGroupDataFromItems) {
          result = _objectSpread(_objectSpread({}, result), getGroupDataFromItems(groupOptions));
        }
        return [].concat(_toConsumableArray(optionsWithGroups), [result], _toConsumableArray(groupOptions));
      }, []);
    }
    return options;
  }, [options, groupBy]);
};
var defaultRenderSubheader = function defaultRenderSubheader(_ref2) {
  var key = _ref2.key,
    label = _ref2.label,
    style = _ref2.style,
    divider = _ref2.divider,
    scrollDivider = _ref2.scrollDivider;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListSubheader["default"], {
    style: style,
    divider: divider,
    scrollDivider: scrollDivider,
    children: label
  }, key);
};
var defaultRenderOption = function defaultRenderOption(_option, _ref3) {
  var label = _ref3.label,
    secondaryLabel = _ref3.secondaryLabel,
    style = _ref3.style,
    index = _ref3.index,
    className = _ref3.className,
    checkbox = _ref3.checkbox,
    selected = _ref3.selected,
    onClick = _ref3.onClick,
    secondaryAction = _ref3.secondaryAction,
    icon = _ref3.icon,
    divider = _ref3.divider,
    scrollDivider = _ref3.scrollDivider,
    actionCount = _ref3.actionCount,
    button = _ref3.button,
    disableGutters = _ref3.disableGutters,
    labelWrap = _ref3.labelWrap;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DataListItem["default"], {
    disableGutters: disableGutters,
    button: button,
    divider: divider,
    scrollDivider: scrollDivider,
    label: label,
    secondaryLabel: secondaryLabel,
    style: style,
    className: className,
    checkbox: checkbox,
    selected: selected,
    onClick: onClick,
    secondaryAction: secondaryAction,
    icon: icon,
    actionCount: actionCount,
    labelWrap: labelWrap
  }, index);
};
var defaultGetOptionLabel = exports.defaultGetOptionLabel = function defaultGetOptionLabel(_ref4) {
  var name = _ref4.name;
  return name;
};
var defaultGetOptionSecondaryLabel = exports.defaultGetOptionSecondaryLabel = function defaultGetOptionSecondaryLabel(_ref5) {
  var secondName = _ref5.secondName;
  return secondName;
};
var defaultGetOptionValue = exports.defaultGetOptionValue = function defaultGetOptionValue(_ref6) {
  var id = _ref6.id;
  return id;
};
var defaultIsSelected = exports.defaultIsSelected = function defaultIsSelected() {
  return false;
};
var DataList = /*#__PURE__*/React.forwardRef(function (_ref7, ref) {
  var options = _ref7.options,
    groupBy = _ref7.groupBy,
    scrollTop = _ref7.scrollTop,
    _ref7$renderOption = _ref7.renderOption,
    renderOption = _ref7$renderOption === void 0 ? defaultRenderOption : _ref7$renderOption,
    _ref7$renderSubheader = _ref7.renderSubheader,
    renderSubheader = _ref7$renderSubheader === void 0 ? defaultRenderSubheader : _ref7$renderSubheader,
    _ref7$getOptionLabel = _ref7.getOptionLabel,
    getOptionLabel = _ref7$getOptionLabel === void 0 ? defaultGetOptionLabel : _ref7$getOptionLabel,
    getOptionLabelText = _ref7.getOptionLabelText,
    getOptionSecondaryLabelText = _ref7.getOptionSecondaryLabelText,
    _ref7$getOptionSecond = _ref7.getOptionSecondaryLabel,
    getOptionSecondaryLabel = _ref7$getOptionSecond === void 0 ? defaultGetOptionSecondaryLabel : _ref7$getOptionSecond,
    _ref7$getOptionValue = _ref7.getOptionValue,
    getOptionValue = _ref7$getOptionValue === void 0 ? defaultGetOptionValue : _ref7$getOptionValue,
    _ref7$isSelected = _ref7.isSelected,
    isSelected = _ref7$isSelected === void 0 ? defaultIsSelected : _ref7$isSelected,
    _ref7$rowHeight = _ref7.rowHeight,
    _rowHeight = _ref7$rowHeight === void 0 ? 54 : _ref7$rowHeight,
    _ref7$isHidden = _ref7.isHidden,
    isHidden = _ref7$isHidden === void 0 ? function () {
      return false;
    } : _ref7$isHidden,
    renderKey = _ref7.renderKey,
    className = _ref7.className,
    scrollToIndex = _ref7.scrollToIndex,
    onScroll = _ref7.onScroll,
    _ref7$divider = _ref7.divider,
    divider = _ref7$divider === void 0 ? true : _ref7$divider,
    checkbox = _ref7.checkbox,
    onItemClick = _ref7.onItemClick,
    secondaryAction = _ref7.secondaryAction,
    icon = _ref7.icon,
    _ref7$button = _ref7.button,
    button = _ref7$button === void 0 ? true : _ref7$button,
    _ref7$actionCount = _ref7.actionCount,
    actionCount = _ref7$actionCount === void 0 ? 1 : _ref7$actionCount,
    disableGutters = _ref7.disableGutters,
    actions = _ref7.actions,
    labelWrap = _ref7.labelWrap,
    withSearch = _ref7.withSearch,
    _ref7$scrollToAlignme = _ref7.scrollToAlignment,
    scrollToAlignment = _ref7$scrollToAlignme === void 0 ? 'center' : _ref7$scrollToAlignme,
    getGroupDataFromItems = _ref7.getGroupDataFromItems,
    noResultsLabel = _ref7.noResultsLabel,
    primaryTypographyProps = _ref7.primaryTypographyProps;
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    heightList = _React$useState2[0],
    setHeightList = _React$useState2[1];
  var handleResize = React.useCallback(function (_ref8) {
    var height = _ref8.height;
    setHeightList(height);
  });
  var _React$useMemo = React.useMemo(function () {
      var heightOptions = options.length * _rowHeight;
      return {
        heightOptionsFull: heightOptions >= heightList,
        heightWithScroll: heightOptions > heightList
      };
    }, [heightList, options.length, _rowHeight]),
    heightOptionsFull = _React$useMemo.heightOptionsFull,
    heightWithScroll = _React$useMemo.heightWithScroll;
  var groupedOptions = useGroupedOptions({
    options: options,
    groupBy: groupBy,
    getGroupDataFromItems: getGroupDataFromItems
  });
  var renderListOption = function renderListOption(_ref9) {
    var index = _ref9.index,
      key = _ref9.key,
      style = _ref9.style;
    var dividerOption = heightOptionsFull ? divider && index !== groupedOptions.length - 1 : divider;
    var option = groupedOptions[index];
    if (option.type === TYPE_GROUP) {
      return renderSubheader(_objectSpread({
        index: index,
        key: option.key,
        label: option.label,
        count: option.count,
        style: style,
        divider: dividerOption,
        scrollDivider: heightWithScroll
      }, option));
    }
    var value = getOptionValue === null || getOptionValue === void 0 ? void 0 : getOptionValue(option);
    var selected = (isSelected === null || isSelected === void 0 ? void 0 : isSelected(option, {
      value: value
    })) || false;
    var label = getOptionLabel === null || getOptionLabel === void 0 ? void 0 : getOptionLabel(option);
    var secondaryLabel = getOptionSecondaryLabel === null || getOptionSecondaryLabel === void 0 ? void 0 : getOptionSecondaryLabel(option);
    var labelText = getOptionLabelText === null || getOptionLabelText === void 0 ? void 0 : getOptionLabelText(option);
    var secondaryLabelText = getOptionSecondaryLabelText === null || getOptionSecondaryLabelText === void 0 ? void 0 : getOptionSecondaryLabelText(option);
    return renderOption(option, {
      value: value,
      selected: selected,
      label: label,
      labelText: labelText,
      secondaryLabel: secondaryLabel,
      secondaryLabelText: secondaryLabelText,
      index: index,
      key: key,
      style: style,
      checkbox: checkbox,
      onClick: onItemClick ? function (e) {
        return onItemClick(e, value, {
          selected: selected
        });
      } : undefined,
      divider: dividerOption,
      scrollDivider: heightWithScroll,
      // scrollDivider is needed for line separator between ListItem and scrollbar
      icon: typeof icon === 'function' ? icon(option) : icon,
      button: button,
      actionCount: actionCount,
      disableGutters: disableGutters,
      secondaryAction: typeof secondaryAction === 'function' ? secondaryAction(option, {
        value: value,
        selected: selected
      }) : secondaryAction,
      labelWrap: labelWrap,
      primaryTypographyProps: primaryTypographyProps
    });
  };
  React.useImperativeHandle(actions, function () {
    return {
      getGroupedOptions: function getGroupedOptions() {
        return _toConsumableArray(groupedOptions);
      },
      getGroupedOptionByIndex: function getGroupedOptionByIndex(index) {
        return groupedOptions[index];
      },
      getGroupedOptionByValue: function getGroupedOptionByValue(value) {
        return groupedOptions.find(function (option) {
          return getOptionValue(option) === value;
        });
      }
    };
  }, [groupedOptions]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ReactVirtualized.AutoSizer, {
    onResize: handleResize,
    children: function children(_ref0) {
      var height = _ref0.height,
        width = _ref0.width;
      var resolvedScrollTop = scrollTop && scrollTop < height ? undefined : scrollTop;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ReactVirtualized.List, {
        ref: ref,
        width: width,
        height: height,
        rowCount: groupedOptions.length,
        rowHeight: function rowHeight(_ref1) {
          var index = _ref1.index;
          var option = groupedOptions[index];
          if (isHidden(option, index)) {
            return 0;
          }
          return _rowHeight;
        },
        rowRenderer: renderListOption,
        className: className,
        scrollToAlignment: scrollToAlignment,
        scrollToIndex: scrollToIndex,
        onScroll: onScroll,
        scrollTop: resolvedScrollTop,
        noRowsRenderer: function noRowsRenderer() {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoResults["default"], {
            inited: !!options,
            filtered: withSearch,
            noResultsLabel: noResultsLabel
          });
        }
      }, renderKey);
    }
  });
});
var _default = exports["default"] = DataList;